import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from '../../../auxiliares/servicios/helper.service';

/**
 * Restringe la vista de Facturación a clientes de nivel 0 (raíz).
 * Otros niveles son redirigidos al mapa.
 */
@Injectable({
  providedIn: 'root',
})
export class FacturacionGuard {
  private helper = inject(HelperService);
  private router = inject(Router);

  canActivate() {
    // Solo cliente nivel 0 según el permiso activo.
    if (this.helper.esClienteNivel0()) {
      return true;
    }
    this.helper.notifWarn('No tiene acceso a la vista de Facturación');
    return this.router.parseUrl('/mapa');
  }
}
